module.exports = {"footer":{"explore":{"title":"Tiếp tục"}}};